/**
 * @file
 * Creates a modal for flagging a message and also a singleton that initializes
 * and opens said modal.
 */

/* eslint
   no-script-url: 0
*/

/* global
	ReportMessage
	ProfileActions
	FeedbackBanner
*/
import PropTypes from "prop-types";
import React from "react";

import GlobalMessaging from "features/global_messaging";
import _str from "shared/util/_str";
import OkC from "shared/util/OkcApi/index";
import Modal from "shared/components/Modal";
import Radio from "shared/components/oknf/OkRadio";
import Str from "shared/components/Str";
import Textarea from "shared/components/oknf/OkTextarea";
import Analytics from "analytics/util/Analytics";

const labelsRequiringDescription = [
	"4", // Underage
	"5", // Assault / Abusive / Violent
];

class ReportMessageModal extends React.Component {
	state = {
		comment: "",
		showSumbissionError: false,
		label: null,
	};

	close = () => {
		ReportMessage.close();
	};

	_flagMessage = () => {
		const { label, comment } = this.state;
		const { userid, threadid, msgid, fromContentWarning, matchPercentage } = this.props;

		const data = {
			// source: one of 'mailbox', 'profile', or 'conversation'
			type: "message",
			label,
			comment,
			id: threadid || msgid,
		};

		if (fromContentWarning) {
			data.auto = true;
		}

		OkC.post(`/profile/${userid}/report`, {
			data,
			success: () => {
				FeedbackBanner.open({
					type: "success",
					message: _str("Report submitted! Retribution will be swift."),
					timeout: 4000,
				});

				Analytics.logUIEvent(Analytics.eventNames.profileReport, {
					data: {
						userid,
						label,
						description: comment,
						messageId: msgid,
						threadId: threadid,
						matchPercentage,
					},
				});

				this.close();

				GlobalMessaging.closeConversation(userid);

				ProfileActions.block(userid, {
					skipModal: true,
					matchPercentage,
				});
			},
			error: () => {
				this.setState({
					showSumbissionError: true,
				});
			},
		});
	};

	_handleSubmit = (e) => {
		e.preventDefault();
		this._flagMessage();
	};

	_setDescription = (e) => {
		this.setState({ comment: e.target.value });
	};

	_setLabel = (label) => {
		return () => {
			this.setState({ label });
		};
	}

	render() {
		const { showSumbissionError, label, comment } = this.state;

		if (showSumbissionError) {
			return (
				<Modal show={true} title={_str("Report a message")} onCancel={this.close}>
					<Str>Something went wrong. Please refresh and try again.</Str>
				</Modal>
			);
		}

		const labelIsHighRisk = labelsRequiringDescription.indexOf(label) !== -1;

		const submittable = !!label && (labelIsHighRisk ? !!comment : true);

		const reasons = [
			{
				text: _str("Aggressive / Harassment"),
				value: "1",
			},
			{
				text: _str("Sexual harassment"),
				value: "2",
			},
			{
				text: _str("Spammer / Scammer / Fake"),
				value: "3",
			},
			{
				text: _str("Minor (under 18 years old)"),
				value: "4",
			},
			{
				text: _str("Offsite behavior: Assault / Abuse / Violence"),
				value: "5",
			},
			{
				text: _str("Other"),
				value: "6",
			},
		];

		return (
			<Modal show={true} title={_str("Report a message")} onCancel={this.close}>
				<form className="oknf oknf--gray" onSubmit={this._handleSubmit}>
					<div className="native-forms-section">
						<h3>
							<Str>Why are you reporting this message?</Str>
						</h3>

						{reasons.map((reason) => (
							<Radio
								key={reason.text}
								name="reportReason"
								label={reason.text}
								onChange={this._setLabel(reason.value)}
								checked={label === reason.value}
								value={reason.value}
							/>
						))}

					</div>

					<div className="native-forms-section">
						<h3>
							{labelIsHighRisk &&
								<Str>Description (Required)</Str>
							}
							{!labelIsHighRisk &&
								<Str>Description</Str>
							}
						</h3>

						<Textarea value={comment} onChange={this._setDescription} />
					</div>

					<button
						className="flatbutton blue"
						type="submit"
						disabled={!submittable}
					>
						<Str>Report it!</Str>
					</button>

					<button
						className="flatbutton silver"
						type="button"
						onClick={this.close}
					>
						<Str>Cancel</Str>
					</button>
				</form>
			</Modal>
		);
	}
}

ReportMessageModal.propTypes = {
	userid: PropTypes.string.isRequired,
	msgid: PropTypes.string,
	threadid: PropTypes.string,
	fromContentWarning: PropTypes.bool,
	matchPercentage: PropTypes.number,
};

export default ReportMessageModal;



// WEBPACK FOOTER //
// ./src/shared/components/ModalReportMessage.jsx